import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppState } from "../../context/AppStateContext";
import { useHardwareSnapshot } from "../../lib/hardwareStore";
import { UpdateDialog } from "./UpdateDialog";

/** The receipt printer's state at a glance (Electron only). Red = the last receipt did not print; click to open the hardware screen. */
export function PrinterPill() {
  const { t } = useTranslation();
  const { setTab } = useAppState();
  const hw = useHardwareSnapshot();
  const [updating, setUpdating] = useState(false);
  if (!hw.native || !hw.status) return null;
  const bad = hw.status.state === "error" || hw.failed.length > 0;
  const none = hw.connection === "none";
  return (
    <>
    <button type="button" onClick={() => setTab("hardware")} title={hw.status.lastError ?? t(`hw.state.${hw.status.state}`)}
      className={`flex items-center gap-1.5 rounded-xl border px-2.5 py-1.5 text-[11px] font-black ${bad ? "border-red-400 bg-red-500/20 text-red-200" : none ? "border-amber-400/60 bg-amber-500/10 text-amber-200" : "border-[#262C66] bg-[#161A42] text-emerald-300"}`}>
      <span aria-hidden>🖨️</span>
      <span className="hidden sm:inline">{none ? t("hw.pill.none") : bad ? t("hw.pill.problem", { count: hw.failed.length }) : t(`hw.state.${hw.status.state}`)}</span>
    </button>
    {hw.updateAvailable && <button type="button" onClick={() => setUpdating(true)} className="rounded-xl bg-solar-orange px-2.5 py-1.5 text-[11px] font-black text-white" title={t("hw.pill.update")} aria-label={t("update.title")}>⬆ <span className="hidden sm:inline">{t("update.badge")}</span></button>}
    {updating && <UpdateDialog onClose={() => setUpdating(false)} />}
    </>
  );
}
